// extracted by mini-css-extract-plugin
module.exports = {"topBar":"PurchaseHistory_topBar__1UEIm","topBarTitle":"PurchaseHistory_topBarTitle__23Gdo","pageContent":"PurchaseHistory_pageContent__3a78b"};